import React, { useState, useRef } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Hint from "../../utils/Hint/Hint";
import MenuCreate from "./MenuCreate/MenuCreate";

import "./menusSection.css";

// Import menu subsections
import { MenuComponentGeneral } from "./_menuComponent/MenuComponent";
import MenuEditorGeneral from "./_menuEditor/menuEditor";

const MenusSection = ({
  allMenus,
  fetchAllMenus,
  isAllMenusLoading,
  handleDeleteMenu,
  handleToggleMenuActive,
  handleUpdateMenu,
  handleCreateNewMenu,
  dishes,
  isDishesLoading
}) => {
  let match = useRouteMatch();
  const [menuCopies, setMenuCopies] = useState([]);
  const [isShowStatic, setIsShowStatic] = useState(false);
  const copiesDiv = useRef(null);

  const handleCopyMenu = (menu) => {
    setMenuCopies((menuCopies) => [...menuCopies, menu]);

    setTimeout(
      () =>
        window.scrollTo({
          top:
            copiesDiv.current.getBoundingClientRect().y + window.scrollY - 100,
          behavior: "smooth"
        }),
      100
    );
  };

  const handleRemoveCopy = (menuId) => {
    setMenuCopies((menuCopies) =>
      menuCopies.filter((menu) => menu._id !== menuId)
    );
  };

  const handleSaveMenuFromCopy = (menu, originalMenuId) => {
    handleCreateNewMenu(menu);

    handleRemoveCopy(originalMenuId);
  };

  return (
    <section className="section menusSection">
      <Hint
        hintHeading="Menus interface"
        hintText={`
        <div>
        <div>
          The interface responsible for handling menus - the main e-commerce tool facing the end-customer.
          </div>
          <div>
          The menu body is selected from the items available in the database, making it a consistent and reliable feature that can be integrated easily in any medium- or small-scale catering enterprise's operation process, automating both production and marketing processes.
          </div>
          <div style="margin-top: .3em;">
          Each menu card contains information about the menu, its role on the website, name, description, menu body, and a set of control buttons.
          </div>
          <div>
          This version of the application supports four menu types: 
          <ol>
          <li>
          <b>Daily menu</b> - items that are currently in stock and available for a day-to-day online order.
          </li>
          <li>
          <b>Order menu</b> - items available for a postponed online order.
          </li>
          <li>
          <b>Static menu</b> - items that can be displayed on the customer-facing website without order functionality. They can be referenced in a concordant manner in <a href="/posts">media posts</a> (e.g., when a set of new products is being released).
          </li>
          <li>
          <b>Printed menu</b> - items that can be saved in a form of PDF document and applied as external-use or internal-use printed materials. This demo demonstrates a basic PDF-document generation, but printed menus' layout can be made color-rich and sophisticated. It can be designed in accordance with the company's brand book, and automatically generate items' pictures and detailed descriptions. Programmatically-generated PDF menus can greatly reduce regular time and money expenses.
          </li>
          </ol>
          </div>
          <div>
Menu types and their behavior can be adjusted according to the business' requirements and the architecture of the customer-facing application.
          </div>
          <div style="margin-top: .3em;">
          Menus can be edited, copied, deleted, and created from scratch.
          </div>
          </div>
        `}
        openOnMount={false}
        top="5em"
      />
      <h2 className="sectionHeading">MENUS</h2>
      <Switch>
        <Route path={`${match.path}/create_menu`}>
          <MenuCreate
            dishes={dishes}
            isDishesLoading={isDishesLoading}
            handleCreateNewMenu={handleCreateNewMenu}
          />
        </Route>
        <Route path={match.path}>
          <h3 style={{ textAlign: "center" }} className="subSection__heading">
            ALL MENUS
          </h3>
          {isAllMenusLoading ? (
            <div className="allMenusLoadingSpinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          ) : null}
          {allMenus &&
            allMenus.map((menu) => (
              <MenuComponentGeneral
                key={menu._id}
                isCopied={
                  menuCopies.findIndex((copy) => copy._id === menu._id) !== -1
                    ? true
                    : false
                }
                handleCopyMenu={() => handleCopyMenu(menu)}
                handleToggleMenuActive={handleToggleMenuActive}
                handleDeleteMenu={handleDeleteMenu}
                handleUpdateMenu={handleUpdateMenu}
                menu={menu}
                dishes={dishes}
              />
            ))}
          <div ref={copiesDiv} style={{ visibility: "hidden", height: 0 }} />
          {menuCopies.length
            ? menuCopies.map((menuCopy, index) => (
                <React.Fragment key={menuCopy._id + index.toString()}>
                  <h3>COPY</h3>
                  <MenuEditorGeneral
                    menu={menuCopy}
                    dishes={dishes}
                    isDishesLoading={isDishesLoading}
                    isFromCopy={true}
                    originalMenuId={menuCopy._id}
                    handleSaveMenu={handleSaveMenuFromCopy}
                    handleCancel={handleRemoveCopy}
                  />
                </React.Fragment>
              ))
            : null}
        </Route>
      </Switch>
    </section>
  );
};

export default MenusSection;
